import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GrupoEditarComponent } from './grupo-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: GrupoEditarComponent }
    ])],
    exports: [RouterModule]
})
export class GrupoEditarRoutingModule { }
